export default {
    state: {
        filterBudget: {}
    },
    getters: {
        FILTER_BUDGET(state) {
            return state.filterBudget;
        }
    },
    actions: {
    },
    mutations: {
        UPDATE_FILTER_BUDGET(state, filter) {
            state.filterBudget = {...filter};
        }

    }
}
